import { Box, Typography } from "@mui/material";

const ContactInfoCard = ({ icon, title, info, bgImage }) => {
  return (
    <Box className="contact-card cst">
      <Box
        className="contact-card-bg"
        style={{ backgroundImage: `url(${bgImage})` }}
      />

      <Box className="contact-card-content">
        <Box className="icon">{icon}</Box>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2">{info}</Typography>
      </Box>
    </Box>
  );
};

export default ContactInfoCard;
